import React, { useState } from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import CurriculumStore from "../../../../stores/CurriculumStore";
import { Spinner, Button, PieTimer } from "../../../-common";
import "./ConfirmDeleteAlbumModal.scss";

function ConfirmDeleteAlbumModal({ curriculum, course, album, close }) {
  const navigate = useNavigate();
  const { id: curriculumId, title: curriculumTitle } = curriculum || {};
  const { id: courseId, name: courseName } = course || {};
  const { id, title: albumTitle } = album || {};

  const [deleteEnabled, setDeleteEnabled] = useState(false);
  const enableDelete = () => setDeleteEnabled(true);

  const [deleting, setDeleting] = useState(false);

  const deleteAlbum = async () => {
    setDeleting(true);
    await CurriculumStore.deleteAlbum({ curriculumId, courseId, albumId: id });
    close();
    navigate(`/curriculum/${curriculumId}/courses/${courseId}`);
  };

  const cancelButtonStyles = deleting ? { opacity: 0.1, pointerEvents: "none" } : {};

  const actionButtonStyles = deleting ? { opacity: 0.3, pointerEvents: "none" } : {};
  const actionButtonContent = deleting ? <Spinner /> : "Delete Album";
  const actionButton = deleteEnabled ? (
    <Button type="negative" action={deleteAlbum} style={actionButtonStyles}>
      {actionButtonContent}
    </Button>
  ) : (
    <div className="timer-container">
      <PieTimer color="var(--red)" width={24} height={24} duration={3000} onComplete={enableDelete} />
    </div>
  );

  return (
    <div className="confirm-delete-course-modal">
      <div className="content">
        <div className="title">
          Are you sure you want to delete {albumTitle} (from {courseName} in {curriculumTitle})?
        </div>
      </div>
      <div className="bottom-buttons">
        <Button action={close} style={cancelButtonStyles}>
          Cancel
        </Button>
        <div className="left-buttons">{actionButton}</div>
      </div>
    </div>
  );
}

export default observer(ConfirmDeleteAlbumModal);
